import React, { useCallback } from "react";
import { diffChars, diffWords, diffSentences, diffJson } from "diff";

const fnMap = {
	chars: diffChars,
	words: diffWords,
	sentences: diffSentences,
	json: diffJson,
};

export const Diff: React.FunctionComponent<{
	newValue: string;
	oldValue: string;
	type?: "chars" | "words" | "sentences" | "json";
	className?: string;
}> = ({ newValue = "", oldValue = "", type = "words", className }) => {
	const findDiff = useCallback(
		(newValue: string, oldValue: string) => {
			const textDiff = fnMap[type](oldValue, newValue);

			return textDiff.map((part, index) => {
				const spanStyle = {
					marginRight: "5px",
					color: part.added ? "#5fb16d" : part.removed && "#802c2c",
					textDecoration: part.removed && "line-through",
				};
				return (
					<span style={spanStyle} key={index}>
						{part.value}
					</span>
				);
			});
		},
		[type],
	);

	const result = oldValue ? findDiff(newValue, oldValue) : newValue;

	return (
		<span style={{ whiteSpace: "pre-wrap" }} className={className}>
			{result}
		</span>
	);
};
